import { Component, ChangeDetectionStrategy, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '@env/environment';
import { SharedService } from '@shared/services/shared.service';
import { IPostRemediationPlan, IRemediationViewModel, IResponseLettersView, ISiteVisitModel } from 'app/models/mainMenu/mainMenu';
import { ISelectItems } from 'app/models/shared/shared';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'app-mainMenu-followupVisit',
  templateUrl: './followupVisit.component.html',
  styleUrls: ['./followupVisit.component.scss'],
  // changeDetection: ChangeDetectionStrategy.Default
})

export class FollowupVisitComponent implements OnInit {
  @Input() countyId: string = '';

  followupVisitList: IRemediationViewModel[] = [];

  displayedColumns: string[] = ['complaintId', 'complaintDate', 'businessName', 'address', 'city', 'zipCode',
    'requiredVisitDate', 'requiredImplementationDate'];
  dataSource = new MatTableDataSource<IRemediationViewModel>(this.followupVisitList);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public complaintService: ComplaintService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Followup Visit
    this.mainMenu.getRemediation(this.countyId).subscribe({
      next: response => {
        this.mainMenu.followupVisitList = response;
        this.dataSource.data = this.mainMenu.followupVisitList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get followups");
      },
    });
  }

  gotoComplaint(compId: string) {
    this.complaintService.complaintId = +compId;
    this.complaintService.complaintTab = 4;
    this.complaintService.complaintVisitTab = 1;
    this.sharedService.doRedirect('complaint/complaint/' + compId);
  }
}